import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { handleHashNavigation } from '../utils/navigation';

const HashNavigationHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash navigation when location changes
    handleHashNavigation();
  }, [location.pathname, location.hash]);

  return null; // This component doesn't render anything
};

export default HashNavigationHandler;